function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M516-191 191-516q-18-20-18-46t18-46l166-165q18-20 45-20t47 20l325 325q19 19 19 46t-19 46L608-191q-18 20-45 20t-47-20Zm14-701 107 107q9 9 9 21t-9 21q-9 9-21.5 9t-21.5-9L419-917q-11-11-6-24t19-16q11-2 23-2.5t23-.5q100 0 187.5 38t153 103.5Q884-753 922-665.5T960-478q0 13-8.5 21.5T930-448q-13 0-21.5-8.5T900-478q0-80-28-151.5T794.5-757Q745-813 677-848.5T530-892ZM433-66 324-175q-9-9-8.5-21t9.5-21q9-9 21.5-9t21.5 9L540-45q11 11 6 25.5T526-2q-12 2-24 2.5T478 1q-99 0-186-37.5t-152-103Q75-205 37.5-292T0-478q0-13 8.5-21.5T30-508q13 0 21.5 8.5T60-478q0 80 28.5 151.5t78.5 127Q217-144 285.5-109T433-66Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#5f6368",
    style: {
      "padding": 3
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/screen-rotate.bd72c22d.svg";
export { SvgComponent as ReactComponent };